var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-textarea',{attrs:{"box":"","rows":_vm.rows,"label":_vm.fieldLabel,"disabled":_vm.readonly},on:{"blur":function($event){return _vm.blurred()}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }